import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  Product,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.owner}owners/${COMMON_QUERY_PARAMS.OWNER_ID}/products`;

interface GetOrderByOwnerIdPayload {
  ownerId: string;
}

export const getListOwnerProductsRequest = (
  payload: GetOrderByOwnerIdPayload,
): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.OWNER_ID, payload.ownerId),
  config: { method: SUPPORTED_METHODS.GET },
});

const getListOwnerProductsQuery = async (
  payload: GetOrderByOwnerIdPayload,
): Promise<BackResponse<Product[]> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<Product[]>>(
      getListOwnerProductsRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default getListOwnerProductsQuery;
